import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- replace with crystal-ui
import { Box, Grid } from '@applyboard/ui-components';
import { CEF_CARD_WIDTH } from "../Common/Constants";
var CefDesktopPageWrapper = function CefDesktopPageWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    maxWidth: CEF_CARD_WIDTH,
    display: "flex",
    flexDirection: "column",
    width: "100%"
  }, children));
};
export default CefDesktopPageWrapper;